// Lazy loading için Intersection Observer kullanacağız
const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            }
            observer.unobserve(img);
        }
    });
}, {
    rootMargin: '50px 0px',
    threshold: 0.1
});

// Sayfa yüklendiğinde çalışacak fonksiyon
document.addEventListener('DOMContentLoaded', () => {
    // Tüm details elementlerini bul
    const detailsElements = document.querySelectorAll('details[data-navmenu-details]');
    
    detailsElements.forEach(details => {
        // Details elementi kapalıyken resimleri engelle
        if (!details.hasAttribute('open')) {
            const images = details.querySelectorAll('img');
            images.forEach(img => {
                // Orijinal src'yi data-src'ye taşı ve src'yi boşalt
                if (img.src) {
                    img.dataset.src = img.src;
                    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                }
            });
        }
        
        // Details elementi açıldığında resimleri yükle
        details.addEventListener('toggle', (event) => {
            if (event.target.open) {
                const images = event.target.querySelectorAll('img');
                images.forEach(img => {
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.removeAttribute('data-src');
                    }
                    // Lazy loading için gözlemlemeye başla
                    imageObserver.observe(img);
                });
            }
        });
    });
});
